<script lang="ts">
  import { localFormData } from "../../lib/dataform/dataFormLib.svelte";
  import HiddenInput from "../../lib/dataform/HiddenInput.svelte";
  import OptionsField from "../../components/uiform/OptionsField";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../components/CloseButton.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";
  import Caret from "~icons/ph/caret-down";
  import { collectDeviceData } from "../../lib/kountConsent";
  import FieldError from "../../components/uiform/FieldError.svelte";

  let {
    checkboardLogo,
    kountLogo,
  }: {
    checkboardLogo: string;
    kountLogo: string;
  } = $props();

  const data = $derived(localFormData());

  const collectKountDeviceData = async () => {
    const success = await collectDeviceData(data.kount_session_id as string);
    if (!success) alert("Fraud prevention check failed. You may need to disable privacy controls in your browser to continue.");
    return success;
  };

  let [label, onclick] = $derived(data.manual_agreement_check_status == "Consented"
    ? ["Consent", collectKountDeviceData]
    : ["Decline", undefined]
  );
</script>

<HiddenInput name="kount_session_id" />

<h2 class="ui-title">No-impact credit check</h2>

<p>
  We can run a soft credit check to quickly find your finance agreements with <b>no impact</b> on your credit rating.
</p>

<details class="ui-details">
  <summary><Caret />
    <span class="ui-open">Hide</span>
    <span class="ui-closed">See details</span>
  </summary>
  <p>
    JLG can conduct a credit check through our trusted vendor, Checkboard Limited, whose Terms &amp; Conditions
    are <a href="https://checkboard.com/terms-and-conditions" target="_blank" rel="noreferrer" class="link text-blue-500">here</a>.
    This has no impact on your credit rating. As part of this process, device information (such as your IP
    address and browser details) will be collected by Kount, an Equifax company, for fraud prevention purposes
    in accordance with <a href="https://kount.com/legal/privacy-policy" target="_blank" rel="noreferrer" class="link text-blue-500">Kount's Privacy Policy</a>.
  </p>
  <div class="flex items-center gap-2">
    <img src={checkboardLogo} class="h-[2.7rem]" alt="Checkboard logo">
    <img src={kountLogo} class="h-[2rem]" alt="Kount logo">
  </div>
</details>

<OptionsField
  name="manual_agreement_check_status"
  legend="Do you want us to run a soft credit check to find your agreements?"
  required
>
  <OptionsField.Option value="Consented">
    Yes
    <div class="text-sm text-gray-500 mt-2">
      We’ll double check addresses on the next screen before running the soft credit check.
    </div>
  </OptionsField.Option>
  <OptionsField.Option value="Declined">
    No, I changed my mind
  </OptionsField.Option>
</OptionsField>

<FieldError name="general" />

<FooterButtons back={false}>
  <CloseButton label="Cancel" />
  <ContinueButton type="submit" {label} {onclick} />
</FooterButtons>
